<app-closable-modal-template class="u-padding">
    <smvd-ui-influencer-reviews-sources-toggle [label]="'REVIEWS.SOURCE' | translate"></smvd-ui-influencer-reviews-sources-toggle>
    <smvd-ui-filter-reviews-buckets
        class="u-padding-bottom u-margin-bottom u-margin-top u-bordered-bottom"
    ></smvd-ui-filter-reviews-buckets>
    <smvd-ui-reviews-segments [reviews]="(externalInfluencerService.externalInfluencer$ | async)?.reviews"> </smvd-ui-reviews-segments>
</app-closable-modal-template>
